import { LogLevel } from "@azure/msal-browser";
import { APIwithoutInterceptor } from "../Axios/Axios";
import { getAuthenticationConfig } from "../Helpers/APIEndpoints/Endpoints";

// APi call to get the Azured ad details from the appsetting.json
// TODO : Neeed to replace the api url.
const response = await APIwithoutInterceptor.post(getAuthenticationConfig);

const data = await response.data;
// Parse AuthType and extract values
const parsedAuthType = JSON.parse(data.data); // Parse the JSON string
// const azureAd = parsedAuthType.authentication.azureAd;
// console.log(azureAd);

console.log("parsedAuthType.redirectUri : " + parsedAuthType.redirectUri);

export const msalConfig = {
    auth: {
        clientId: parsedAuthType.clientId,
        authority: `${parsedAuthType.authority}${parsedAuthType.tenantId}`,
        redirectUri: parsedAuthType.redirectUri,
        postLogoutRedirectUri: "/",
    },
    cache: {
        cacheLocation: "sessionStorage", // or "sessionStorage"
        storeAuthStateInCookie: false, // Set to true if you need to support IE11
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
            logLevel: LogLevel.Info,
        },
    },
};

export const loginRequest = {
    scopes: ["user.read", "openid", "profile", "email"],
};


// import { LogLevel } from "@azure/msal-browser";

// // Define a default msalConfig object to hold placeholders
// export let msalConfig: any = null;

// // Define a function to fetch the configuration from an API
// export const fetchAuthConfig = async () => {
//     try {
//         const response = await fetch("/api/config/azure-ad"); // Replace with your API endpoint
//         if (!response.ok) {
//             throw new Error("Failed to fetch Azure AD configuration.");
//         }
//         const config = await response.json();

//         // Update the msalConfig object with fetched values
//         msalConfig = {
//             auth: {
//                 clientId: config.clientId,
//                 authority: config.authority,
//                 redirectUri: config.redirectUri || "http://localhost:5173/",
//                 postLogoutRedirectUri: config.postLogoutRedirectUri || "/",
//             },
//             cache: {
//                 cacheLocation: "localStorage", // or "sessionStorage"
//                 storeAuthStateInCookie: false, // Keep this as is
//             },
//             system: {
//                 loggerOptions: {
//                     loggerCallback: (level: any, message: any, containsPii: any) => {
//                         if (containsPii) return;
//                         switch (level) {
//                             case LogLevel.Error:
//                                 console.error(message);
//                                 break;
//                             case LogLevel.Info:
//                                 console.info(message);
//                                 break;
//                             case LogLevel.Verbose:
//                                 console.debug(message);
//                                 break;
//                             case LogLevel.Warning:
//                                 console.warn(message);
//                                 break;
//                         }
//                     },
//                     logLevel: LogLevel.Info, // Keep this as is
//                 },
//             },
//         };

//         return msalConfig; // Return the updated configuration
//     } catch (error) {
//         console.error("Error fetching Azure AD configuration:", error);
//         throw error;
//     }
// };

// // Define loginRequest scopes as static
// export const loginRequest = {
//     scopes: ["user.read", "openid", "profile", "email"], // Keep this as is
// };

